import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetopandhartuljapurcab() {



    const cardData = {

keyword: "Pune to Pandharpur Tuljapur Cabs",

headingDescription:
    "Rising Cab Service offers safe, comfortable, and reliable Pune to Pandharpur Tuljapur Cabs for families, devotees, and pilgrimage travelers. We provide well-maintained Sedan, SUV, Innova Crysta, Tempo Traveller, and luxury vehicles with experienced chauffeurs for a smooth spiritual journey across Maharashtra. Our service includes doorstep pickup from Pune, flexible one-way and round-trip packages, 24/7 support, and transparent pricing, ensuring a peaceful and hassle-free darshan experience at both Pandharpur and Tuljapur.",

topPlaces: [
    {
        title: "Shri Vitthal Rukmini Temple, Pandharpur",
        description:
            "Shri Vitthal Rukmini Temple is one of the most sacred pilgrimage sites in Maharashtra, dedicated to Lord Vitthal (a form of Lord Krishna). Located on the banks of the Chandrabhaga River, it attracts millions of devotees especially during Ashadhi Ekadashi for spiritual darshan and devotion."
    },
    {
        title: "Chandrabhaga River Ghat",
        description:
            "The Chandrabhaga River Ghat is a holy bathing and ritual site near the Vitthal temple. Devotees believe that taking a dip in the river purifies the soul, and the serene surroundings add to the spiritual experience of Pandharpur."
    },
    {
        title: "Pundalik Temple",
        description:
            "Pundalik Temple is dedicated to Saint Pundalik, who is believed to have brought Lord Vitthal to Pandharpur. It holds deep mythological and spiritual importance in the Warkari tradition."
    },
    {
        title: "Tuljapur Bhavani Temple",
        description:
            "Tuljapur Bhavani Temple is one of the 51 Shakti Peeths dedicated to Goddess Bhavani (a form of Goddess Durga). It is a highly powerful spiritual site where devotees seek strength, protection, and blessings."
    },
    {
        title: "Ghat Shila Temple Area",
        description:
            "The temple surroundings in Tuljapur include sacred stones and shrines associated with Goddess Bhavani. The peaceful environment and traditional rituals make it a deeply spiritual destination."
    },
    {
        title: "Kolhapur–Pandharpur Route Temples",
        description:
            "The highway route between Pune, Pandharpur, and Tuljapur passes through several small temples and devotional spots, making the journey spiritually enriching for pilgrims traveling by cab."
    },
    {
        title: "Vitthal Rukmini Mandir Complex Viewpoints",
        description:
            "The temple complex area in Pandharpur offers peaceful river views, temple ghats, and devotional gathering spaces, especially vibrant during pilgrimage seasons and festivals."
    },
    {
        title: "Tuljapur Fort Surroundings",
        description:
            "The region around Tuljapur includes old fort remnants and elevated viewpoints offering scenic landscapes and a calm environment near the temple town."
    },
    {
        title: "Shegaon (Optional Route Extension)",
        description:
            "Many pilgrims extend their journey to Shegaon to visit Shri Gajanan Maharaj Temple, another major spiritual destination in Maharashtra known for its peace and divine atmosphere."
    },
    {
        title: "Warkari Pilgrimage Path",
        description:
            "The traditional Warkari pilgrimage route to Pandharpur is filled with devotional energy, chanting groups, and rural Maharashtra landscapes, making the cab journey spiritually meaningful and culturally rich."
    }
],



services: [
  {
    name: "Pune to Pandharpur Cab Service",
    description: "Rising Cab Service offers Pune to Pandharpur Cab Service for a smooth and comfortable pilgrimage journey to Lord Vitthal’s holy city. We provide well-maintained AC Sedan, SUV, Innova Crysta, and Tempo Traveller options with professional drivers, doorstep pickup, and 24x7 support. Ideal for families, groups, and devotees seeking a safe and peaceful travel experience with flexible scheduling and affordable pricing."
  },
  {
    name: "Pune to Pandharpur Taxi Service",
    description: "Book Pune to Pandharpur Taxi Service with Rising Cab Service for reliable and safe intercity travel designed especially for pilgrimage visitors. Our experienced chauffeurs ensure timely pickup, smooth highway driving, and comfortable journey experience. We focus on cleanliness, safety, and customer satisfaction for a stress-free religious trip."
  },
  {
    name: "Pune to Pandharpur Cab Booking",
    description: "Rising Cab Service provides instant Pune to Pandharpur Cab Booking with multiple vehicle choices and easy confirmation process. Whether you need a one way or round trip cab, we offer flexible options with transparent pricing and 24x7 booking support. Enjoy a hassle-free travel experience with professional service and reliable transport."
  },
  {
    name: "Pune to Pandharpur One Way Cab",
    description: "Our Pune to Pandharpur One Way Cab service is perfect for passengers who need a simple drop to Pandharpur without return charges. We offer affordable fares, clean AC vehicles, and experienced drivers for long-distance comfort. This service ensures budget-friendly and convenient pilgrimage travel."
  },
  {
    name: "Pune to Pandharpur Round Trip Taxi",
    description: "Rising Cab Service offers Pune to Pandharpur Round Trip Taxi for devotees planning same-day or multi-day return journeys. Enjoy flexible waiting time, safe driving, and comfortable vehicles suitable for family and group travel. Our round trip packages ensure convenience and cost-effective pilgrimage planning."
  },
  {
    name: "Pune to Pandharpur Innova Crysta Cab",
    description: "Book Pune to Pandharpur Innova Crysta Cab for premium comfort, spacious seating, and smooth highway travel experience. Ideal for families and group pilgrims, our Innova Crysta ensures luxury, safety, and long-distance comfort with professional chauffeurs and well-maintained vehicles."
  },
  {
    name: "Pune to Pandharpur Pilgrimage Cab",
    description: "Rising Cab Service provides Pune to Pandharpur Pilgrimage Cab designed specifically for spiritual travelers visiting Pandharpur temple. We ensure peaceful travel, flexible stops for darshan, and comfortable journey arrangements. Our service focuses on devotion-friendly travel with complete convenience."
  },
  {
    name: "Pune to Pandharpur Sedan Cab Service",
    description: "Our Pune to Pandharpur Sedan Cab Service is ideal for small families and budget travelers looking for comfortable and affordable pilgrimage transport. We provide clean, air-conditioned sedans with trained drivers ensuring smooth and safe highway travel."
  },
  {
    name: "Pune to Pandharpur SUV Cab Service",
    description: "Rising Cab Service offers Pune to Pandharpur SUV Cab Service for larger families and groups needing extra space and comfort. Our SUVs are well-maintained, AC-enabled, and perfect for long-distance religious journeys with maximum comfort and safety."
  },
  {
    name: "Pune to Pandharpur Tempo Traveller",
    description: "Book Pune to Pandharpur Tempo Traveller for group pilgrimage travel with spacious seating, comfortable interiors, and professional drivers. This service is ideal for large families, satsang groups, and temple tours ensuring a coordinated and comfortable journey."
  },
  {
    name: "Pune to Pandharpur Outstation Cab",
    description: "Rising Cab Service provides Pune to Pandharpur Outstation Cab with safe long-distance travel, flexible pickup options, and reliable highway driving. We ensure clean vehicles, experienced chauffeurs, and affordable pricing for all types of travelers."
  },
  {
    name: "Pune to Pandharpur Religious Tour Cab",
    description: "Our Pune to Pandharpur Religious Tour Cab is designed for devotees seeking a complete spiritual travel experience. We provide comfortable transportation, flexible darshan stops, and well-planned pilgrimage support for a peaceful and meaningful journey."
  },

  {
    name: "Pune to Tuljapur Cab Service",
    description: "Rising Cab Service offers Pune to Tuljapur Cab Service for devotees visiting the sacred Tulja Bhavani Temple. We provide safe, comfortable, and reliable AC cabs with professional drivers ensuring smooth highway travel and timely arrival for darshan."
  },
  {
    name: "Pune to Tuljapur Taxi Service",
    description: "Book Pune to Tuljapur Taxi Service with Rising Cab Service for a convenient and stress-free pilgrimage journey. Our experienced drivers ensure safe driving, clean vehicles, and on-time service for families and devotees traveling to Tuljapur."
  },
  {
    name: "Pune to Tuljapur Cab Booking",
    description: "Rising Cab Service provides easy Pune to Tuljapur Cab Booking with instant confirmation, multiple vehicle options, and transparent pricing. Enjoy hassle-free travel planning with 24x7 booking support and reliable transportation service."
  },
  {
    name: "Pune to Tuljapur One Way Cab",
    description: "Our Pune to Tuljapur One Way Cab service is perfect for passengers needing affordable drop-only travel. We offer clean AC vehicles, professional drivers, and budget-friendly pricing for a smooth and convenient journey."
  },
  {
    name: "Pune to Tuljapur Round Trip Taxi",
    description: "Rising Cab Service offers Pune to Tuljapur Round Trip Taxi for same-day return or flexible travel plans. Enjoy safe driving, comfortable vehicles, and waiting time options suitable for family and group pilgrimages."
  },
  {
    name: "Pune to Tuljapur Innova Crysta Cab",
    description: "Book Pune to Tuljapur Innova Crysta Cab for premium comfort and spacious travel experience. Ideal for families and groups, our Innova Crysta ensures smooth, safe, and luxurious pilgrimage travel with professional chauffeurs."
  },
  {
    name: "Pune to Tuljapur Pilgrimage Cab",
    description: "Rising Cab Service provides Pune to Tuljapur Pilgrimage Cab designed for devotees visiting Tulja Bhavani Temple. We ensure peaceful travel, flexible stops, and comfortable arrangements for a smooth spiritual journey."
  },
  {
    name: "Pune to Tuljapur Sedan Cab Service",
    description: "Our Pune to Tuljapur Sedan Cab Service is perfect for small families and budget travelers looking for safe and affordable temple travel. We provide clean, AC sedans with experienced drivers for comfortable long-distance journeys."
  },
  {
    name: "Pune to Tuljapur SUV Cab Service",
    description: "Rising Cab Service offers Pune to Tuljapur SUV Cab Service for larger groups needing extra space and comfort. Our SUVs are well-maintained, air-conditioned, and ideal for smooth pilgrimage travel with family and friends."
  },
  {
    name: "Pune to Tuljapur Tempo Traveller",
    description: "Book Pune to Tuljapur Tempo Traveller for group pilgrimage trips with spacious seating and comfortable interiors. This service is perfect for large families and devotional groups seeking coordinated and hassle-free travel."
  },
  {
    name: "Pune to Tuljapur Outstation Cab",
    description: "Rising Cab Service provides Pune to Tuljapur Outstation Cab with safe long-distance travel, professional drivers, and affordable pricing. Enjoy reliable service with comfortable vehicles and flexible pickup options."
  },
  {
    name: "Pune to Tuljapur Religious Tour Cab",
    description: "Our Pune to Tuljapur Religious Tour Cab offers a complete pilgrimage experience to Tulja Bhavani Temple with safe transport, flexible scheduling, and comfortable AC vehicles designed for devotees."
  }
],

tableData: [
  ["Pune to Pandharpur Cab Service", "Pune to Tuljapur Cab Service"],
  ["Pune to Pandharpur Taxi Service", "Pune to Tuljapur Taxi Service"],
  ["Pune to Pandharpur Cab Booking", "Pune to Tuljapur Cab Booking"],
  ["Pune to Pandharpur One Way Cab", "Pune to Tuljapur One Way Cab"],
  ["Pune to Pandharpur Round Trip Taxi", "Pune to Tuljapur Round Trip Taxi"],
  ["Pune to Pandharpur Innova Crysta Cab", "Pune to Tuljapur Innova Crysta Cab"],
  ["Pune to Pandharpur Pilgrimage Cab", "Pune to Tuljapur Pilgrimage Cab"],
  ["Pune to Pandharpur Sedan Cab Service", "Pune to Tuljapur Sedan Cab Service"],
  ["Pune to Pandharpur SUV Cab Service", "Pune to Tuljapur SUV Cab Service"],
  ["Pune to Pandharpur Tempo Traveller", "Pune to Tuljapur Tempo Traveller"],
  ["Pune to Pandharpur Outstation Cab", "Pune to Tuljapur Outstation Cab"],
  ["Pune to Pandharpur Religious Tour Cab", "Pune to Tuljapur Religious Tour Cab"]
],



whychoose: [
    {
        WhyChooseheading: "Comfortable Pune to Pandharpur Tuljapur Cab Service",
        WhyChoosedescription: "Rising Cab Service provides reliable Pune to Pandharpur Tuljapur cab transportation for devotees, families, senior citizens, and pilgrimage groups seeking a peaceful spiritual journey."
    },
    {
        WhyChooseheading: "Visit Two Sacred Pilgrimage Destinations",
        WhyChoosedescription: "Travel conveniently to Shri Vitthal Rukmini Temple in Pandharpur and Shri Tulja Bhavani Temple in Tuljapur with a well-planned pilgrimage itinerary."
    },
    {
        WhyChooseheading: "Customized Religious Tour Packages",
        WhyChoosedescription: "Customers can choose same-day tours, overnight pilgrimage trips, weekend packages, and customized temple visit plans according to their schedule."
    },
    {
        WhyChooseheading: "Comfortable Vehicles for Temple Travel",
        WhyChoosedescription: "Choose from Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles suitable for families and larger pilgrimage groups."
    },
    {
        WhyChooseheading: "Perfect for Family and Senior Citizen Pilgrimages",
        WhyChoosedescription: "Our cab services offer flexibility, comfort, and doorstep travel, making temple visits easier for devotees of all age groups."
    },
    {
        WhyChooseheading: "Pickup Available Across Pune & PCMC",
        WhyChoosedescription: "Doorstep pickup facilities are available from Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, Kothrud, Wagholi, Pimpri Chinchwad, and nearby locations."
    },
    {
        WhyChooseheading: "Experienced Drivers for Pilgrimage Routes",
        WhyChoosedescription: "Our drivers are familiar with temple routes and ensure safe, smooth, and comfortable travel throughout the pilgrimage."
    },
    {
        WhyChooseheading: "Hassle-Free Darshan Travel Experience",
        WhyChoosedescription: "Rising Cab Service helps devotees focus on their spiritual journey while we manage transportation and travel arrangements."
    }
]
};

const faqData = [
    {
        question: "Which temples are covered in the Pune to Pandharpur Tuljapur cab package?",
        answer: "The package includes Shri Vitthal Rukmini Temple in Pandharpur and Shri Tulja Bhavani Temple in Tuljapur."
    },
    {
        question: "Can I complete Pandharpur and Tuljapur Darshan in one trip?",
        answer: "Yes, both destinations can be covered in a single pilgrimage trip depending on the travel schedule and Darshan timings."
    },
    {
        question: "Which vehicle is suitable for family temple tours?",
        answer: "Ertiga and Innova Crysta are among the most preferred options due to their comfortable seating and spacious interiors."
    },
    {
        question: "Are Tempo Travellers available for pilgrimage groups?",
        answer: "Yes, Tempo Travellers and larger vehicles can be arranged for family groups, bhajan mandals, and religious organizations."
    },
    {
        question: "Can senior citizens comfortably travel on this pilgrimage route?",
        answer: "Yes, private cab travel offers flexibility and convenience, making it suitable for senior citizens and families."
    },
    {
        question: "Can I book a one-way cab for Pandharpur or Tuljapur?",
        answer: "Yes, one-way transportation and round-trip packages are both available."
    },
    {
        question: "Can additional pilgrimage destinations be included in the tour?",
        answer: "Yes, destinations such as Akkalkot, Gangapur, Solapur, and other religious places can be added to the itinerary."
    },
    {
        question: "Are pickups available from Pune Airport and Railway Station?",
        answer: "Yes, passengers can start their pilgrimage from Pune Airport, Railway Station, hotels, offices, or residential locations."
    },
    {
        question: "Is advance booking recommended during Ashadhi and Kartiki Yatra?",
        answer: "Yes, advance reservations are highly recommended during major pilgrimage seasons and festival periods."
    },
    {
        question: "How can I book a Pune to Pandharpur Tuljapur Cab?",
        answer: "Bookings can be confirmed through phone calls, WhatsApp messages, website inquiries, or online booking forms with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Prakash Wagh",
        feedback:
            "Our Pandharpur and Tuljapur pilgrimage was arranged perfectly. The vehicle was comfortable, the travel schedule was well planned, and the entire journey felt peaceful and convenient.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Sunita Jadhav",
        feedback:
            "Traveling with elderly family members became very easy through Rising Cab Service. We completed both temple visits comfortably and appreciated the professional service throughout the trip.",
        rating: 5
    }
];






    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];












const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune to Pandharpur / Tuljapur Cab Service",
"image": "https://www.risingcabservice.com/assets/images/pune-to-pandharpur-cab.jpg",
"description": "Book Pune to Pandharpur and Tuljapur Cab Service with Rising Cab Service for safe and comfortable pilgrimage travel. Enjoy reliable one-way and round-trip taxi service with AC sedans, SUVs, and Innova cars for temple darshan.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/pune-to-pandharpur-tuljapur-cab"
}
};






    return (
        <div>


<Helmet>
  <title>Pune to Pandharpur / Tuljapur Cab Service | Temple Taxi | +91 9272511548</title>

<meta
 name="description"
 content="Book Pune to Pandharpur and Tuljapur Cab Service for safe and comfortable temple travel. Get affordable one-way and round-trip taxi service with AC sedans, SUVs, and Innova cars."
/>

<meta
 name="keywords"
 content="pune to pandharpur cab, pune to pandharpur taxi, cab from pune to pandharpur, taxi from pune to pandharpur, pune to pandharpur cab service, pune to pandharpur taxi fare, pune to pandharpur one way cab, pune to pandharpur round trip taxi, pune to pandharpur cab booking, cheap pune to pandharpur cab, best pune to pandharpur taxi, Pune to Tuljapur cab, Tuljapur darshan cab pune, temple cab pune pandharpur tuljapur"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>

            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/68.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetopandhartuljapurcab;